import actions from './slide-attributes.actions'
import { mutations } from './slide-attributes.mutations'

const _state = {}
export default {
  namespaced: true,
  actions,
  state: _state,
  mutations,
}
